import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getContext } from 'svelte';

var root = $.from_html(`<span class="truncate"> </span>`);

export default function Select_value($$anchor, $$props) {
	$.push($$props, true);

	let placeholder = $.prop($$props, 'placeholder', 3, 'Select an option');
	const select = getContext('select');
	const displayValue = $.derived(() => select.getSelected().label || placeholder());
	var span = root();
	var text = $.child(span, true);

	$.reset(span);
	$.template_effect(() => $.set_text(text, $.get(displayValue)));
	$.append($$anchor, span);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsic2VsZWN0LXZhbHVlLnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgeyBnZXRDb250ZXh0IH0gZnJvbSAnc3ZlbHRlJztcblxuICBsZXQge1xuICAgIHBsYWNlaG9sZGVyID0gJ1NlbGVjdCBhbiBvcHRpb24nLFxuICB9OiB7XG4gICAgcGxhY2Vob2xkZXI/OiBzdHJpbmc7XG4gIH0gPSAkcHJvcHMoKTtcblxuICBjb25zdCBzZWxlY3QgPSBnZXRDb250ZXh0PHtcbiAgICBnZXRTZWxlY3RlZDogKCkgPT4geyB2YWx1ZTogc3RyaW5nOyBsYWJlbDogc3RyaW5nIH07XG4gIH0+KCdzZWxlY3QnKTtcblxuICBjb25zdCBkaXNwbGF5VmFsdWUgPSAkZGVyaXZlZChzZWxlY3QuZ2V0U2VsZWN0ZWQoKS5sYWJlbCB8fCBwbGFjZWhvbGRlcik7XG48L3NjcmlwdD5cblxuPHNwYW4gY2xhc3M9XCJ0cnVuY2F0ZVwiPlxuICB7ZGlzcGxheVZhbHVlfVxuPC9zcGFuPlxuIl0sIm1hcHBpbmdzIjoiOztTQUNXLFVBQVUsUUFBUSxRQUFROzs7O3dEQURyQyxDQUFDOzs7S0FJRyxXQUFXLHFDQUFHLGtCQUFrQjtPQUs1QixNQUFNLEdBQUcsVUFBVSxDQUV0QixRQUFRO09BRUwsWUFBWSxtQkFBWSxNQUFNLENBQUMsV0FBVyxHQUFHLEtBQUssSUFBSSxXQUFXOzs7OztnREFJdEUsWUFBWTs7O0FBSGhCLENBQUMifQ==